import { StatusHistory } from "../member-management/member-info.model";

export class MemberFacebookDataModel {
  public id: string;
  public name: string;
  public email: string;
  // public dob: Date;
  public gender: string;
  // public currentCity: string;
  public profilePictureUrl: string;
  public coverPictureUrl: string;
  public profileUrl: string;
  // public recentPictures: Picture[];
  public friendsCount: number;
  public memberConnections: Friend[];
  // public workHistory: Job[];
  // public educationHistory: School[];
  // public checkIns: CheckIn[];
  // public events: Event[];
  // public pageLikes: PageLike[];
  public ageRange: string;
}
export class Picture {
  public id: string;
  public thumbnailUrl: string;
  public url: string;
  public createdTime: Date;
}
export class Friend {
  public id: string;
  public name: string;
}
export class CheckIn {
  public id: string;
  public name: string;
  public time: Date;
}
export class Job {
  public id: string;
  public name: string;
  public startDate: Date;
  public endDate: Date;
}
export class School {
  public id: string;
  public name: string;
  public graduationYear: number;
  public type: string;
}
export class Event {
  public id: string;
  public name: string;
  public location: string;
  public startTime: Date;
  public endTime: Date;
}
export class PageLike {
  public id: string;
  public pageName: string;
}


export class MemberDetailsResponseModel {
  public name: string;
  public email: string;
  public workEmail: string;
  public registrationDate: Date;
  public doB: Date;
  public invitedByFullName: string;
  public invitedById: number;
  public memberFavourites: string;
  public industry: string;
  public employerOrUniversity: string;
  public jobRole: string;
  public membershipNumber: number;
  public status: string;
  public membershipType: string;
  // What the applicant asked for, as opposed to membershipType, which is what they hold. The API
  // falls back to their actual type for rows that predate the field, so it is never empty.
  public appliedMembershipTypeString: string;
  // Accepted, but the membership payment has not succeeded. Hides Accept / Waitlist / Reject.
  public acceptancePaymentPending: boolean;
  public expiryDate: Date;
  public canCreatePremiumInvitationCodes: boolean;
  public standardInvitationsLeft: number;
  public premiumInvitationsLeft: number;
  public standardInvitationsUsed: number;
  public premiumInvitationsUsed: number;
  public image: string;
  public hasFacebook: boolean;
  public linkedIn: string;
  public twitter: string;
  public website: string;
  public instagram: string;
  public screenshot: string;
  public statusHistory: StatusHistory[];;
}

export class MemberStatusModel {
  public userId: number;
  public memberId: number;
  public status: string;
}




// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/application-management-popup.model.ts